import React, { FC, useEffect } from "react";
import Enquiry from "../../../Enquiry";
import { getAllCenters } from "../../../../store/centers/thunks";
import {
  useAppDispatch as useDispatch,
  useAppSelector as useSelector,
} from "../../../../store";
import { TAllCentersList } from "../../../../store/centers/types";
import Loader from "../../../Loader";

const CentreEnquiry: FC = () => {
  const dispatch = useDispatch();

  const centerUserList = useSelector((state) => state.Centres.allCentreUsers);
  const allCentersList = useSelector((state) => state.Centres.allCenters);
  const isLoading = useSelector((state) => state.Centres.inProgress);

  useEffect(() => {
    dispatch(getAllCenters());
  }, [dispatch]);

  return (
    <>
      {isLoading && (
        <div className="transparent-preloader">
          <Loader />
        </div>
      )}
      <div className="d-flex flex-column flex-lg-row gap-50">
        <div className="d-flex flex-column gap-20 min-w-176px w-176px mobile-w-100 text-break">
          <div className="fs-16 fw-700 text-black">
            {centerUserList?.length} Centre Users{" "}
          </div>
          <div className="w-100 h-1px bg-off-white"></div>
          <div className="d-flex gap-10 align-items-center justify-content-between">
            <div
              className="fs-16 fw-700 text-teal-dark cursor-pointer"
              onClick={() => {
                window.location.href = "/client/centres";
              }}
            >
              {allCentersList?.length} Centres
            </div>
            <svg
              className="min-w-24px cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22C6.47715 22 2 17.5229 2 12ZM12 3.81818C7.4813 3.81818 3.81818 7.4813 3.81818 12C3.81818 16.5187 7.4813 20.1818 12 20.1818C16.5187 20.1818 20.1818 16.5187 20.1818 12C20.1818 7.4813 16.5187 3.81818 12 3.81818ZM12 7.45455C12.5021 7.45455 12.9091 7.86156 12.9091 8.36364V11.0909H15.6364C16.1384 11.0909 16.5455 11.4979 16.5455 12C16.5455 12.5021 16.1384 12.9091 15.6364 12.9091H12.9091V15.6364C12.9091 16.1384 12.5021 16.5455 12 16.5455C11.4979 16.5455 11.0909 16.1384 11.0909 15.6364V12.9091H8.36364C7.86156 12.9091 7.45455 12.5021 7.45455 12C7.45455 11.4979 7.86156 11.0909 8.36364 11.0909H11.0909V8.36364C11.0909 7.86156 11.4979 7.45455 12 7.45455Z"
                fill="#167E76"
              />
            </svg>
          </div>
          {allCentersList.map((centreData: TAllCentersList) => (
            <div
              key={centreData.id}
              className="fs-16 text-black cursor-pointer"
              onClick={() => {
                localStorage.setItem(
                  "centre_id",
                  JSON.stringify(centreData.id)
                );
                window.location.href = "/client/centres";
              }}
            >
              {centreData.business_name}
            </div>
          ))}
        </div>
        <div className="border-left border-off-white pl-50px w-100 mobile-p-0 mobile-border-0 d-flex flex-column gap-20">
          <Enquiry />
        </div>
      </div>
    </>
  );
};

export default CentreEnquiry;
